import { categories, products } from "./dummyData";

export const getCategories = async ({ searchTerm } = {}) => {
    if (searchTerm) {
        const filteredCategories = categories.filter(category => category.name.toLowerCase().includes(searchTerm.toLowerCase()));
        return filteredCategories;
    }
    return categories;
};
export const getProducts = async ({ searchTerm, selectedCategories, page = 1, perPage = 6 }) => {
    // Add some delay time
    await new Promise(resolve => setTimeout(resolve, 2000));
    const filter = [];
  
    // Add filter for search term
    if (searchTerm) {
      filter.push(product => product.name.toLowerCase().includes(searchTerm.toLowerCase()));
    }
  
    // Add filter for selected categories
    if (selectedCategories && selectedCategories.length > 0) {
      filter.push(product => selectedCategories.some(category => product.categorySlug === category.slug));
    }
  
    // If we have filters, apply them
    if (filter.length > 0) {
      const filteredProducts = products.filter(product => 
        filter.every(fn => fn(product)) // Apply all filters to each product
      ).slice((page - 1) * perPage, page * perPage);
      
      return {
        products: filteredProducts,
        hasMore: filteredProducts.length > page * perPage,
      };
    }
  
    // If no filters, return all products
    return {
      products: products.slice((page - 1) * perPage, page * perPage),
      hasMore: products.length > page * perPage,
    };
  };

export const getPrintPrice = async () => {
    
    return {
      optionsPricing: {
        "A3;Black & White;Recto": 4,
        "A3;Black & White;Recto-Verso": 3,
        "A3;Color;Recto": 5,
        "A3;Color;Recto-Verso": 6,
        "A4;Black & White;Recto": 2,
        "A4;Black & White;Recto-Verso": 4,
        "A4;Color;Recto": 3,
        "A4;Color;Recto-Verso": 5,
        "A5;Black & White;Recto": 3,
        "A5;Black & White;Recto-Verso": 5,
        "A5;Color;Recto": 4,
        "A5;Color;Recto-Verso": 6,
        "A6;Black & White;Recto": 4,
        "A6;Black & White;Recto-Verso": 2,
        "A6;Color;Recto": 5,
        "A6;Color;Recto-Verso": 3,
    },
    fasteningPricing: {
      "None": 0,
      "Staple": 10,
      "Stitch": 15,
      "Glue Binding": 20,
      "Spiral Binding": 10,
      "Comb Binding": 10,
    }
  };
};

export const getActualPrice = async (selectedItems) => {
  console.log("getActualPrice :", selectedItems);
  return 120;
}

export const checkout = async (submitData) => {
  console.log("submitData checkout :", submitData);
  // wait for 2 seconds
  await new Promise(resolve => setTimeout(resolve, 2000));
}